import React, { useState, useEffect, useRef } from 'react';
import { Grid, Typography, FormControlLabel, Radio, Button, Checkbox } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import SignatureCanvas from 'react-signature-canvas';
import ClearIcon from '@material-ui/icons/Clear';
import TextField from '@material-ui/core/TextField';
import Styles from './styles';
import SignatureUploadField from '../SignatureUploadField';


export default function Signature({ handleSubmit, handleBackPage, TargetLanguageCode, onChangeData }) {
    const classes = Styles()

    const signPad = React.createRef();
    const [width, setWidth] = useState(window.innerWidth);
    const [submitData, setSubmitData] = useState({});
    const [acceptDisableStatus, setAcceptDisableStatus] = useState(true)
    const theme = useTheme();
    const sm = useMediaQuery(theme.breakpoints.up('sm'));
    const [content, setContent] = useState('');
    const [fontStyle, setFontStyle] = useState('Dancing Script, cursive');
    const [signType, setSignType] = useState('draw_signature');
    const signaturePreviewRef = useRef(null);

    const handleInput = async (event) => {
        setContent(event.target.value);
        let _content = event.target.value;
        setSubmitData((prevData) => {
            return {
                ...prevData,
                client_signature: _content.trim() ? {
                    fontFamily: fontStyle,
                    text: _content,
                    ref: signaturePreviewRef.current
                } : null
            }
        });
    };  

    const handleFontChange = async (event) => {
        setFontStyle(event.target.value);
        let font = event.target.value;
        setSubmitData((prevData) => {
            return {
                ...prevData,
                client_signature: content.trim() ? {
                    fontFamily: font,
                    text: content,
                    ref: signaturePreviewRef.current
                } : null
            }
        });
    };

    const editorStyle = {
        width: '100%',
        padding: '10px',
        height: '40px',
        outline: 'none',
        border: '0.5px solid rgb(255 255 255)'
    };

    const previewStyle = {
        border: '1px solid #ccc',
        height: '100px',
        padding: '24px',
        border: '0.5px solid rgb(255 255 255)'
    };

    const signatureOptions = [
        {
            label: 'Draw Signature',
            value: 'draw_signature',
        },
        {
            label: 'Enter Signature',
            value: 'enter_signature_text',
        },
        {
            label: 'Upload Signature',
            value: 'upload_signature',
        }
    ];

    const fontStyles = {
        style1: { label: 'Dancing Script', fontFamily: 'Dancing Script, cursive' },
        style2: { label: 'Great Vibes', fontFamily: 'Great Vibes, cursive' },
        style3: { label: 'Pacifico', fontFamily: 'Pacifico, cursive' },
        style4: { label: 'Satisfy', fontFamily: 'Satisfy, cursive' },
        style5: { label: 'Courgette', fontFamily: 'Courgette, cursive' },
        style6: { label: 'Lobster', fontFamily: 'Lobster, cursive' },
        style7: { label: 'Handlee', fontFamily: 'Handlee, cursive' },
        style8: { label: 'Sacramento', fontFamily: 'Sacramento, cursive' },
        style9: { label: 'Allura', fontFamily: 'Allura, cursive' },
        style10: { label: 'Mr Dafoe', fontFamily: 'Mr Dafoe, cursive' },
        style11: { label: 'Parisienne', fontFamily: 'Parisienne, cursive' },
        style12: { label: 'Lobster Two', fontFamily: 'Lobster Two, cursive' },
        style13: { label: 'Shadows Into Light', fontFamily: 'Shadows Into Light, cursive' },
        style14: { label: 'Kaushan Script', fontFamily: 'Kaushan Script, cursive' },
        style15: { label: 'Cookie', fontFamily: 'Cookie, cursive' },
        style16: { label: 'Homemade Apple', fontFamily: 'Homemade Apple, cursive' },
        style17: { label: 'Allan', fontFamily: 'Allan, cursive' },
        style18: { label: 'Cedarville Cursive', fontFamily: 'Cedarville Cursive, cursive' },
        style19: { label: 'Parisienne', fontFamily: 'Parisienne, cursive' },
        style20: { label: 'Yellowtail', fontFamily: 'Yellowtail, cursive' },
    };

    useEffect(() => {
        let mounted = true;
        window.addEventListener('resize', () => setWidth(window.innerWidth));
        return () => mounted = false;
    }, []);

    useEffect(() => {
        setSubmitData((prevData) => {
            return {
                ...prevData,
                client_signature: null
            }
        });
    }, [signType])

    useEffect(() => {
        console.log(submitData)
        let mounted = true;
        if(mounted) acceptBtnDisableStatus();
        return () => mounted = false;
    }, [submitData])


    const handleClear = () => {
        signPad.current.clear();
        setSubmitData(Object.assign({}, { ...submitData }, { 'client_signature': null }))
    }

    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;
        
        if(value && value != 'false' || checked){
            setSubmitData(Object.assign({}, { ...submitData }, { [name]: type === 'checkbox' ? checked : value }));
            onChangeData(Object.assign({}, { ...submitData }, { [name]: type === 'checkbox' ? checked : value }));
        } else {
            delete submitData[name];
            setSubmitData(Object.assign({}, submitData));
            onChangeData(Object.assign({}, submitData));
        }
        
    }

    const handleRadioButtonChange = (e) => {
        setSignType(e.target.value)
    }

    const acceptBtnDisableStatus = () => {
        if(submitData && submitData.client_signature && submitData.Terms && submitData.County && submitData.County.trim()) {
            setAcceptDisableStatus(false);
        } else {
            setAcceptDisableStatus(true)
        }
    }

    return (
        <Grid>
            <Grid item xs={12} style={{ color: "#464444", marginBottom: '12px' }}>
                <Grid container direction="row" justify="space-between">
                    <Grid style={{ display: 'inline-grid', maxWidth: '570px' }}>
                        <Typography variant="inherit" style={{ paddingTop: '10px', paddingBottom: '6px', color: '#000000', fontSize: '13px' }}>
                            {TargetLanguageCode === 'es' ? `Al firmar a continuación, certifica bajo pena de perjurio que las respuestas que ha proporcionado y revisado son verdaderas y precisas según su leal saber y entender.` : TargetLanguageCode === 'vi' ? `Bằng cách ký tên bên dưới, bạn chứng thực theo hình phạt nếu khai man rằng các câu trả lời bạn đã cung cấp và xem xét là đúng và chính xác theo hiểu biết của bạn.` : TargetLanguageCode === 'cmn' ? `通过在下面签名，您证明您所提供和审查的答案据您所知是真实和准确的，否则愿受伪证罪处罚。` : `By signing below you attest under the penalty of perjury that the answers you've provided and reviewed are true and accurate to the best of your knowledge.`}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} style={{marginTop: '12px', marginBottom: '12px'}}>
                <TextField
                    name={"County"}
                    type="text"
                    label={<span className={classes.textSize} > {TargetLanguageCode === 'es' ? `Ingrese al condado` : TargetLanguageCode === 'vi' ? `Nhập Quận` : TargetLanguageCode === 'cmn' ? `输入县` : `Enter County`} </span>}
                    placeholder={TargetLanguageCode === 'es' ? `Condado` : TargetLanguageCode === 'vi' ? `Quận hạt` : TargetLanguageCode === 'cmn' ? `县` : `County`}
                    className={classes.fieldColor}
                    fullWidth
                    value={submitData && submitData.County || ''}
                    InputProps={{
                        classes: {
                            input: classes.inputField
                        }
                    }}
                    onChange={handleChange} />
                    {!submitData.County && <span className={classes.error}>{TargetLanguageCode === 'es' ? `Requerida` : TargetLanguageCode === 'vi' ? `Yêu cầu` : TargetLanguageCode === 'cmn' ? `必需的` : `Required` }</span>}
            </Grid>  
            <div style={{ display: 'flex', marginBottom: '20px' }}>
                {signatureOptions.map((opt, index) => (!opt.disableRecord &&
                    <Grid item >
                        <FormControlLabel
                            className={classes.RadioBtn}
                            control={<Radio
                                key={index}
                                style={{ color: "#2ca01c" }}
                                value={opt.value}
                                checked={signType == opt.value}
                                onChange={(e) => handleRadioButtonChange(e, opt)} />}
                            label={<span style={{ fontSize: '15px' }} dangerouslySetInnerHTML={{ __html: opt.label }} />} />
                    </Grid>
                ))}
            </div>
            {signType === 'draw_signature' && 
                <> 
                    <Grid item xs={12} style={{ color: "#464444", marginBottom: '12px' }}>
                        <Grid container direction="row" justify="space-between">
                            <Grid style={{ display: 'inline-grid', maxWidth: '570px' }}>
                                <Typography variant="inherit">
                                    {TargetLanguageCode === 'es' ? 'Dibuja tu firma aquí' : TargetLanguageCode === 'vi' ? 'Vẽ chữ ký của bạn ở đây' : TargetLanguageCode === 'cmn' ? `在这里签名` : 'Draw your signature here'}
                                </Typography>
                                <Grid style={{ marginTop: '20px' }}>
                                    <Button 
                                        variant="contained" 
                                        className={classes.btnClear} 
                                        startIcon={<ClearIcon />} 
                                        onClick={handleClear}
                                    >
                                        {TargetLanguageCode === 'es' ? 'Clara' : TargetLanguageCode === 'vi' ? 'Rỏ ràng' : TargetLanguageCode === 'cmn' ? `清除` : 'Clear'}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} style={{ backgroundColor: "rgb(128 128 128 / 38%)" }}>
                        <SignatureCanvas penColor='black'
                            canvasProps={{ width: !sm ? width - 80 : 560, height: 200, className: 'signCanvas' }}
                            ref={signPad}
                            onEnd={(e) => setSubmitData(Object.assign({}, { ...submitData }, { 'client_signature': signPad.current.getTrimmedCanvas().toDataURL('image/png') }))} 
                        />
                    </Grid>
                </>
            }

            {signType === 'enter_signature_text' && 
                <Grid container>
                    <div style={{ width: '100%' }}>
                        <Grid item>
                            <div>
                                <label className={classes.textLabel} htmlFor="name">Name</label>
                                <input className={classes.inputField} id='name' placeholder='Enter your name here...' style={editorStyle} onChange={handleInput} />
                            </div>
                            <div className={classes.inputGrid}>
                                <label className={classes.textLabel} htmlFor="fontStyle">Choose Font: </label>
                                <div>
                                    <select className={classes.inputField} style={{ width: '100%', height: '40px', border: '0.5px solid rgb(255 255 255)' }} id="fontStyle" value={fontStyle} onChange={handleFontChange}>
                                        {Object.keys(fontStyles).map((font) => {
                                            return <option key={font} style={{ fontFamily: fontStyles[font].fontFamily }} value={fontStyles[font].fontFamily}>{fontStyles[font].label}</option>
                                        })}
                                    </select>
                                </div>
                            </div>
                            <div className={classes.inputGrid}>
                                <label className={classes.textLabel}>Preview Signature</label>
                                <div className={classes.inputField} style={previewStyle}>
                                    <div ref={signaturePreviewRef} style={{ fontFamily: fontStyle, fontSize: '35px', display: 'inline-block' }}>{content}</div>
                                </div>
                            </div>
                        </Grid>
                    </div>
                </Grid>
            }

            {signType === 'upload_signature' && 
                <Grid container>
                    <Grid item xs={12}>
                        <SignatureUploadField setSubmitData={setSubmitData} />
                    </Grid>
                </Grid>
            }
            <Grid item xs={12} style={{ marginTop: "25px", marginBottom: "15px" }} >
                <FormControlLabel
                    name="Terms"
                    control={<Checkbox style={{ color: "green" }}
                        value={submitData && submitData.Terms || false}
                        onChange={handleChange} />}
                    label={TargetLanguageCode === 'es' ? `Acepto utilizar registros y firmas electrónicos` : TargetLanguageCode === 'vi' ? `Tôi đồng ý sử dụng hồ sơ và chữ ký điện tử ` : TargetLanguageCode === 'cmn' ? `我同意使用电子记录和签名` : `I agree to use electronic records and signatures`}
                />
            </Grid>
            <Grid container direction="row" style={sm ? null : { flexWrap: 'initial' }} justify="flex-end" alignItems="center" className={classes.btnGrid}>
                <Button type="button" variant="contained" className={classes.btnBack} style={sm ? { width: 150 } : null} onClick={handleBackPage} >{TargetLanguageCode === 'es' ? 'atrás' : TargetLanguageCode === 'vi' ? 'Lưng' : TargetLanguageCode === 'cmn' ? `后退` : 'Back'}</Button>
                <Button type="button" className={classes.btnAccept} style={sm ? { width: 250 } : null} disabled={acceptDisableStatus} variant="contained" color="primary" onClick={() => handleSubmit(submitData)}>{TargetLanguageCode === 'es' ? 'Aceptar' : TargetLanguageCode === 'vi' ? 'Chấp nhận' : TargetLanguageCode === 'cmn' ? `接受` : 'Accept'}</Button>
            </Grid>
        </Grid>
    )
}
